import { IconProps } from 'types';

const Workflow = ({ className, title = 'Workflow' }: IconProps) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{title}</title>
        <circle cx="5" cy="6" r="2" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="19" cy="6" r="2" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="18" r="2" stroke="currentColor" strokeWidth="1.5" />
        <path
            d="M5 8v2a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <line
            x1="12"
            y1="14"
            x2="12"
            y2="16"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export default Workflow;
